import { FaTelegramPlane, FaInstagram } from "react-icons/fa";

const SocialLinks = () => {
  return (
    <div className="mainpage__socials">
      <div>
        <a href="https://t.me/mun_dev" target="_blank" rel="noreferrer">
          <FaTelegramPlane />
        </a>
      </div>
      <div>
        <FaInstagram />
      </div>
    </div>
  );
};

export default SocialLinks;
